import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { Category } from "../../model/Category";
import { LogoUploader } from "../ShopEditor/LogoUploader";

type CategoryFormProps = {
  category: Category;
  setCategory: (category: Category) => void;
  errors: any;
  validateField: (name: string, value: string) => void;
};

export function CategoryForm({
  category,
  setCategory,
  errors,
  validateField,
}: CategoryFormProps) {
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    validateField(name, value);
    setCategory({ ...category, [name]: value });
  };
  const handleDrop = (acceptedFiles: File[]) => {
    setCategory({ ...category, imageFile: acceptedFiles[0] } as Category);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom mb={2}>
          Information de la catégorie
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Nom de la catégorie"
              name="name"
              value={category.name}
              onChange={handleChange}
              fullWidth
              required
              error={errors.name}
              helperText={errors.name ? "Ce champ est obligatoire" : ""}
            />
          </Grid>
          <Grid item xs={12}>
            <LogoUploader
              logo={
                category.imageFile !== undefined
                  ? URL.createObjectURL(category.imageFile)
                  : category.imageUrl!
              }
              onDrop={handleDrop}
              title={"Image de la catégorie"}
              required={true}
              error={errors.imageFile}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
